export default "__VITE_ASSET__C5WY32CD__"